import AuthenticationOverlay from 'components/core/Overlay/AuthenticationOverlay';
import OverlayProvider, { OverlayID } from 'components/core/Overlay/OverlayProvider';
import { useState } from 'react';
import { VStack } from 'reaction';

function PrivateSafe() {
    const [locked, setLocked] = useState(true);

    const togglePassword = (id: OverlayID | null) => setLocked(id === null ? false : true);

    return (
        <VStack>
            <OverlayProvider open={locked ? 1 : null} opener={togglePassword}>
                <AuthenticationOverlay />
            </OverlayProvider>
        </VStack>
    );
}

export default PrivateSafe;
